import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Line} from 'react-chartjs-2';
import '../../../styles/global.scss';
import Skeleton from 'react-loading-skeleton';
import {Segment, Dimmer, Loader} from "semantic-ui-react";

/**
 * Base class for conventional charts
 * @extends Component
 */
export default class UnitChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chartData: {
                labels: this.props.labels,
                datasets: this.props.datasets
            },
            options: this.props.options
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.labels !== this.props.labels || prevProps.datasets !== this.props.datasets || prevProps.options !== this.props.options) {
            this.setState({
                chartData: {
                    labels: this.props.labels,
                    datasets: this.props.datasets
                },
                options: this.props.options
            });
        }
    }
    

    
    render() {
        const ChartType = this.props.chartType || Line;
        const { plugins } = this.props; // Extract plugins from props

        return (
            <Segment className={`chart-segment ${this.props.size}`}>
                <Dimmer active={this.props.isLoading}>
                    <Loader indeterminate>Refreshing Chart</Loader>
                </Dimmer>
                <ChartType
                    width={0}

                    responsive={true}
                    data={this.state.chartData || <Skeleton />}
                    options={this.state.options}
                    plugins={plugins} // Pass plugins to the ChartType component
                />
               
            </Segment>
        )
    }
}

UnitChart.propTypes = {
    labels: PropTypes.array.isRequired,
    datasets: PropTypes.array.isRequired,
    options: PropTypes.object,
    chartType: PropTypes.elementType,
    isLoading: PropTypes.bool,
    size: PropTypes.oneOf(["small","compress", "medium", "large"]),
    plugins: PropTypes.array // Add plugins to propTypes
};